module.exports = __webpack_public_path__ + "static/media/mix.8b07298f.jpg";